import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { UserQuickCreatorMobileModal } from './QuickCreatorMobileModal';
import { UserQuickCreatorModal } from './QuickCreatorModal';
import { createUser } from '../../../Users/actions';
import { setNewCompanyValue } from '../../../Companies/actions';
import { selectWork } from '../../../Api/selectors';
import { CREATE_USER } from '../../constants';

const Container = styled.div`
  z-index: ${props => (props.innerWidth <= 768 ? '102' : '10000')};
  position: fixed;
`;

const STATE = {
  user: {
    name: '',
    surname: '',
    email_address: '',
    phone: '',
  },
};

/* eslint-disable react/prefer-stateless-function */
class UserQuickCreatorComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  save() {
    const { name, surname, email_address, phone } = this.state.user;

    const userDto = {
      email_address,
      password: '',
      properties: [
        { name: 'name', value: name },
        { name: 'surname', value: surname },
        { name: 'phone', value: phone },
      ],
    };

    this.props.createUser(userDto, result => {
      if (result) {
        if (this.props.forNewCompany) {
          this.props.setNewCompanyValue(result?.id, 'contact');

          this.props.setNewCompanyValue(result?.id, 'relation_financial_contact_id');

          this.props.setNewCompanyValue(result?.id, 'relation_commercial_contact_id');

          this.props.setNewCompanyValue(result?.id, 'relation_vehicle_documents_contact_id');
          this.reset();
        }

        if (this.props.kanban) {
          this.props.setNewCompanyValue(result?.id, 'relation_financial_contact_id');
          this.reset();
        }
      }
    });
  }

  get selectedRoles() {
    return {
      // financial_contact: this.state.financial_contact,
      // commercial_contact: this.state.commercial_contact,
      // document_contact: this.state.document_contact,
      financial_contact: '1',
      commercial_contact: '1',
      document_contact: '1',
    };
  }

  setUser(name, value) {
    this.setState((prev, props) => {
      return { ...prev, user: { ...prev.user, [name]: value } };
    });
    return this;
  }

  setRole(role) {
    if (this.state[role] == '1') {
      this.setState({ [role]: '0' });
      return;
    }
    this.setState({ [role]: '1' });
  }

  reset() {
    this.props.reset();
  }

  render() {
    return (
      <Container innerWidth={window.innerWidth}>
          <UserQuickCreatorModal
            workCreate={this.props.workCreate}
            newUser={this.state?.user}
            setUser={this.setUser.bind(this)}
            roles={this.selectedRoles}
            setRole={this.setRole.bind(this)}
            onSave={this.save.bind(this)}
            onCancel={this.reset.bind(this)}
          /> 
      </Container>
    );
  }
}

UserQuickCreatorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workCreate: selectWork(CREATE_USER),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setNewCompanyValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewCompanyValue(name, value));
    },
    createUser(user, callback) {
      dispatch(createUser(user, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserQuickCreator = compose(withConnect, withRouter)(UserQuickCreatorComp);
